import { debounce } from 'lodash';
import { useState } from 'react';

const useKeyword = (): [string, (value: string) => void] => {
  const [keyword, setKeyword] = useState<string>('');

  const onChange = (value: string) => setKeyword(value);

  const debouncedChange = debounce(onChange, 300);

  return [keyword, debouncedChange];
};

export default useKeyword;
